import {serverApi} from '../../api/serverAPI'

const datas = {
  getProduct: (storeId, productId) => new Promise((resolve, reject) => {
    serverApi.get('/mailchimp/ecommerce/' + storeId + '/product/' + productId)
      .then(function (response) {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  }),
  createProduct: ({...args}) => new Promise((resolve, reject) => {
    console.log('args', args)
    serverApi.post('/mailchimp/ecommerce/product/create', args)
      .then(function (response) {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  }),
  updateProduct: ({...args}) => new Promise((resolve, reject) => {
    console.log('args', args)
    serverApi.post('/mailchimp/ecommerce/product/update', args)
      .then(function (response) {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  }),
  updateVariant: ({...args}) => new Promise((resolve, reject) => {
    console.log('args', args)
    serverApi.post('/mailchimp/ecommerce/variant/update', args)
      .then(function (response) {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}
export default datas



// WEBPACK FOOTER //
// ./src/components/Products/api.js